import App from './App.vue'
import store from './store'
import router from './router'
import './assets/tailwind.css'
import './registerServiceWorker'
import ru from './locales/ru.json'
import uz from './locales/uz.json'
import en from './locales/en.json'
import { createI18n } from 'vue-i18n'
import 'vue3-toastify/dist/index.css'
import * as Sentry from "@sentry/vue"
import VueLazyload from 'vue-lazyload'
import { computed, createApp } from 'vue'
import { AVPlugin } from 'vue-audio-visual'
import { createYmaps } from 'vue-yandex-maps'
import { useUseragent } from '@/helpers/useragent.js'
import { YANDEX_MAP_KEY } from '@/constants/index.js'
import formatBalance from '@/helpers/formatBalance.js'
import VueTailwindDatepicker from 'vue-tailwind-datepicker'

const supportedLocales = ['ru', 'uz', 'en']

let locale = localStorage.getItem('locale')
const useragent = computed(() => useUseragent().getUserAgent())

if (!locale) {
  if (['alipayClient', 'alipayConnect'].includes(useragent.value)) {
    locale = 'en'
  } else {
    const browserLang = (navigator.language || 'ru').split('-')[0]
    locale = supportedLocales.includes(browserLang) ? browserLang : 'ru'
  }
}

localStorage.setItem('locale', locale)

const i18n = createI18n({
  locale: locale,
  fallbackLocale: 'ru',
  messages: { ru, uz, en },
  legacy: false
})

const app = createApp(App)

Sentry.init({
  app,
  dsn: "https://8b226684b3459bc76f12d84c956c1cd7@sentry.multidev.uz/20",
  sendDefaultPii: true
})

app.use(router)
  .use(store)
  .use(i18n)
  .use(AVPlugin)
  .use(VueTailwindDatepicker)
  .use(VueLazyload, {
    preLoad: 1.3,
    error: '/img/dummy.png',
    loading: '/img/dummy.png',
    attempt: 1
  })
  .use(createYmaps({
    apikey: YANDEX_MAP_KEY,
    lang: locale
  }))
  .mount('#app')

app.config.globalProperties.formatBalance = formatBalance
